import PropTypes from "prop-types";

import { getBootstrapData } from "@swa-ui/bootstrap";
import { withFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  StateAndCountryAutocomplete,
  stateAndCountryAutocompletePropTypes,
} from "../StateAndCountryAutocomplete";
import { COUNTRY_SCHEMA_FIELD_NAME } from "./CountryFormField.schema";

/**
 * CountryFormField provides support for a StateAndCountryAutocomplete component to be used in a Form.
 */
export const CountryFormField = (props) => {
  const { className, componentProps, disabled, name = COUNTRY_SCHEMA_FIELD_NAME, label } = props;

  return withFormField(StateAndCountryAutocomplete, { useController: true })(
    getCountryFormFieldProps()
  );

  function getCountriesData() {
    return (
      getBootstrapData("countries-data")?.map(({ countryCode, fullName }) => ({
        displayValue: fullName,
        label: fullName,
        value: countryCode,
      })) || []
    );
  }

  function getCountryFormFieldProps() {
    return {
      className,
      componentProps: {
        "aria-label": i18n("CountryFormField__ARIA"),
        list: getCountriesData(),
        ...componentProps,
      },
      disabled,
      label: label ?? i18n("CountryFormField__LABEL"),
      name,
      useController: true,
    };
  }
};

export const countryFormFieldPropTypes = {
  /** Additional class for positioning the component. */
  className: PropTypes.string,

  /** Component props for StateAndCountryAutocomplete component. */
  componentProps: PropTypes.shape(stateAndCountryAutocompletePropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Content above the form field, used to identify the form field. */
  label: PropTypes.string,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

CountryFormField.propTypes = countryFormFieldPropTypes;
